/* ==========================================================================
   Twin Cities Bead Bazaar — behaviour for the custom Dawn sections
   - countdown timer
   - email popup (timed / scroll / exit-intent, remembers dismissals)
   - sticky mobile bar
   - "Add to calendar" .ics download
   - share / copy link
   - "I might want a booth" tag toggle on the signup form
   - Lead event for Shopify Forms / Klaviyo forms hosted in the signup section
   - TCBB.track(): sends events to the Meta Pixel (and dataLayer if present)
   Loaded with `defer` from every tcbb-* section; guarded so it runs once.
   ========================================================================== */
(function () {
  if (window.TCBB) return;

  var TCBB = (window.TCBB = {});

  var store = {
    get: function (k) {
      try {
        return window.localStorage.getItem(k);
      } catch (e) {
        return null;
      }
    },
    set: function (k, v) {
      try {
        window.localStorage.setItem(k, v);
      } catch (e) {}
    },
    sget: function (k) {
      try {
        return window.sessionStorage.getItem(k);
      } catch (e) {
        return null;
      }
    },
    sset: function (k, v) {
      try {
        window.sessionStorage.setItem(k, v);
      } catch (e) {}
    },
  };

  /* ---------------------------------------------------------------- tracking */
  TCBB.track = function (name, params, custom) {
    params = params || {};
    try {
      if (window.fbq) window.fbq(custom ? 'trackCustom' : 'track', name, params);
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'tcbb_' + name.toLowerCase() }, params));
    } catch (e) {}
  };

  TCBB.isSubscribed = function () {
    return store.get('tcbb_subscribed') === '1';
  };

  TCBB.markSubscribed = function () {
    store.set('tcbb_subscribed', '1');
    document.querySelectorAll('[data-tcbb-sticky]').forEach(function (el) {
      el.hidden = true;
    });
    document.querySelectorAll('[data-tcbb-popup]').forEach(function (dlg) {
      if (dlg.open) dlg.close();
    });
  };

  // Shopify reloads the page with ?customer_posted=true after a successful signup.
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    TCBB.markSubscribed();
  }

  /* ------------------------------------------------------------------ utils */
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function ymd(d) {
    return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate());
  }

  function toast(msg) {
    var el = document.querySelector('.tcbb-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'tcbb-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2600);
  }

  var isDesignMode = !!(window.Shopify && window.Shopify.designMode);

  /* -------------------------------------------------------------- countdown */
  function initCountdowns() {
    document.querySelectorAll('[data-tcbb-countdown]').forEach(function (el) {
      if (el.dataset.tcbbInit) return;
      el.dataset.tcbbInit = '1';

      var start = new Date(el.dataset.start);
      var end = new Date(el.dataset.end);
      if (isNaN(start) || isNaN(end)) return;

      var units = {
        days: el.querySelector('[data-unit="days"]'),
        hours: el.querySelector('[data-unit="hours"]'),
        minutes: el.querySelector('[data-unit="minutes"]'),
        seconds: el.querySelector('[data-unit="seconds"]'),
      };
      var status = el.querySelector('[data-tcbb-countdown-status]');

      function tick() {
        var now = new Date();
        el.classList.remove('tcbb-countdown--live', 'tcbb-countdown--over');
        if (now >= end) {
          el.classList.add('tcbb-countdown--over');
          if (status) status.textContent = el.dataset.afterText || '';
          return;
        }
        if (now >= start) {
          el.classList.add('tcbb-countdown--live');
          if (status) status.textContent = el.dataset.liveText || '';
          return;
        }
        var diff = Math.max(0, start - now);
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        s -= d * 86400;
        var h = Math.floor(s / 3600);
        s -= h * 3600;
        var m = Math.floor(s / 60);
        s -= m * 60;
        if (units.days) units.days.textContent = d;
        if (units.hours) units.hours.textContent = pad(h);
        if (units.minutes) units.minutes.textContent = pad(m);
        if (units.seconds) units.seconds.textContent = pad(s);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  /* ------------------------------------------------------------------ popup */
  function initPopups() {
    document.querySelectorAll('[data-tcbb-popup]').forEach(function (dlg) {
      if (dlg.dataset.tcbbInit) return;
      dlg.dataset.tcbbInit = '1';
      if (typeof dlg.showModal !== 'function') return;

      var delay = parseInt(dlg.dataset.delay || '0', 10);
      var scrollPct = parseInt(dlg.dataset.scroll || '0', 10);
      var exitIntent = dlg.dataset.exit === 'true';
      var dismissDays = parseInt(dlg.dataset.dismissDays || '7', 10);
      var key = 'tcbb_popup_dismissed';
      var opened = false;

      function suppressed() {
        if (TCBB.isSubscribed()) return true;
        var ts = parseInt(store.get(key) || '0', 10);
        return ts && Date.now() - ts < dismissDays * 86400 * 1000;
      }

      function open() {
        if (opened || dlg.open) return;
        if (!isDesignMode && suppressed()) return;
        opened = true;
        dlg.showModal();
        TCBB.track('SignupPopupView', {}, true);
      }

      function close() {
        if (dlg.open) dlg.close();
      }

      dlg.addEventListener('close', function () {
        store.set(key, String(Date.now()));
      });
      dlg.addEventListener('click', function (e) {
        // click on the backdrop closes
        if (e.target === dlg) close();
      });
      dlg.querySelectorAll('[data-tcbb-popup-close]').forEach(function (btn) {
        btn.addEventListener('click', close);
      });

      // Theme editor: open when the merchant selects the section, close on deselect.
      if (isDesignMode) {
        var section = dlg.closest('.shopify-section');
        document.addEventListener('shopify:section:select', function (e) {
          if (section && section.contains(e.target)) open();
        });
        document.addEventListener('shopify:section:deselect', function (e) {
          if (section && section.contains(e.target)) {
            close();
            opened = false;
          }
        });
        return;
      }

      if (suppressed()) return;

      if (delay > 0) setTimeout(open, delay * 1000);

      if (scrollPct > 0) {
        var onScroll = function () {
          var max = document.documentElement.scrollHeight - window.innerHeight;
          if (max <= 0) return;
          if ((window.scrollY / max) * 100 >= scrollPct) {
            window.removeEventListener('scroll', onScroll);
            open();
          }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }

      if (exitIntent && window.matchMedia('(pointer: fine)').matches) {
        document.addEventListener('mouseleave', function (e) {
          if (e.clientY <= 0) open();
        });
      }
    });
  }

  /* ------------------------------------------------------------- sticky bar */
  function initStickyBars() {
    document.querySelectorAll('[data-tcbb-sticky]').forEach(function (bar) {
      if (bar.dataset.tcbbInit) return;
      bar.dataset.tcbbInit = '1';

      if (TCBB.isSubscribed() || store.sget('tcbb_sticky_dismissed')) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;
      var showAfter = parseInt(bar.dataset.showAfter || '500', 10);

      function update() {
        bar.classList.toggle('is-visible', window.scrollY > showAfter);
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
      if (isDesignMode) bar.classList.add('is-visible');

      var closeBtn = bar.querySelector('[data-tcbb-sticky-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          store.sset('tcbb_sticky_dismissed', '1');
          bar.hidden = true;
        });
      }
    });
  }

  /* --------------------------------------------------------- add to calendar */
  function buildIcs(d) {
    var days = [];
    var startParts = d.start.split('-').map(Number);
    var endParts = d.end.split('-').map(Number);
    var cur = new Date(startParts[0], startParts[1] - 1, startParts[2]);
    var last = new Date(endParts[0], endParts[1] - 1, endParts[2]);
    var guard = 0;
    while (cur <= last && guard < 14) {
      days.push(new Date(cur));
      cur.setDate(cur.getDate() + 1);
      guard++;
    }
    var esc = function (s) {
      return String(s || '')
        .replace(/\\/g, '\\\\')
        .replace(/\r?\n/g, '\\n')
        .replace(/,/g, '\\,')
        .replace(/;/g, '\\;');
    };
    var t = function (hm) {
      return hm.replace(':', '') + '00';
    };
    var now = new Date();
    var stamp =
      ymd(new Date(now.getTime() + now.getTimezoneOffset() * 60000)) +
      'T' +
      pad(now.getUTCHours()) +
      pad(now.getUTCMinutes()) +
      pad(now.getUTCSeconds()) +
      'Z';
    var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Twin Cities Bead Bazaar//Event//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH'];
    days.forEach(function (day, i) {
      var summary = d.name + (days.length > 1 ? ' (day ' + (i + 1) + ' of ' + days.length + ')' : '');
      lines.push(
        'BEGIN:VEVENT',
        'UID:tcbb-' + d.start + '-' + i + '@' + window.location.hostname,
        'DTSTAMP:' + stamp,
        'DTSTART;TZID=' + d.tz + ':' + ymd(day) + 'T' + t(d.open),
        'DTEND;TZID=' + d.tz + ':' + ymd(day) + 'T' + t(d.close),
        'SUMMARY:' + esc(summary),
        'LOCATION:' + esc(d.location),
        'DESCRIPTION:' + esc(d.description),
        'URL:' + d.url,
        'END:VEVENT'
      );
    });
    lines.push('END:VCALENDAR');
    return lines.join('\r\n');
  }

  function initIcsButtons() {
    document.querySelectorAll('[data-tcbb-ics]').forEach(function (btn) {
      if (btn.dataset.tcbbInit) return;
      btn.dataset.tcbbInit = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var d = btn.dataset;
        var ics = buildIcs({
          name: d.name,
          start: d.start,
          end: d.end,
          open: d.open,
          close: d.close,
          tz: d.tz || 'America/Chicago',
          location: d.location,
          description: d.description,
          url: d.url || window.location.href,
        });
        var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'twin-cities-bead-bazaar.ics';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () {
          URL.revokeObjectURL(url);
        }, 2000);
        TCBB.track('AddToCalendar', {}, true);
      });
    });
  }

  /* ------------------------------------------------------------------ share */
  function initShareButtons() {
    document.querySelectorAll('[data-tcbb-share]').forEach(function (btn) {
      if (btn.dataset.tcbbInit) return;
      btn.dataset.tcbbInit = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var data = {
          title: btn.dataset.title || document.title,
          text: btn.dataset.text || '',
          url: btn.dataset.url || window.location.href,
        };
        TCBB.track('Share', {}, true);
        if (navigator.share) {
          navigator.share(data).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(data.url).then(
            function () {
              toast(btn.dataset.copied || 'Link copied — send it to a bead friend!');
            },
            function () {
              window.prompt('Copy this link:', data.url);
            }
          );
        } else {
          window.prompt('Copy this link:', data.url);
        }
      });
    });
  }

  /* --------------------------------------------------- vendor-interest toggle */
  function initVendorToggles() {
    document.querySelectorAll('[data-tcbb-vendor-toggle]').forEach(function (cb) {
      if (cb.dataset.tcbbInit) return;
      cb.dataset.tcbbInit = '1';
      var form = cb.closest('form');
      var tags = form && form.querySelector('[data-tcbb-tags]');
      if (!tags) return;
      var base = tags.dataset.baseTags || tags.value;
      var extra = tags.dataset.vendorTag || 'tcbb-vendor-lead';
      var update = function () {
        tags.value = cb.checked ? base + ', ' + extra : base;
      };
      cb.addEventListener('change', update);
      update();
    });
  }

  /* --------------------------------------------- app / Klaviyo signup forms */
  // When the signup section hosts a Shopify Forms block or a Klaviyo embed,
  // the native success page never loads, so mirror the Lead event here.
  function fireLead(source) {
    TCBB.markSubscribed();
    TCBB.track('Lead', { content_name: 'attendee_signup', content_category: 'email_list', source: source });
  }

  function initAppForms() {
    document.querySelectorAll('[data-tcbb-app-form]').forEach(function (slot) {
      if (slot.dataset.tcbbInit) return;
      slot.dataset.tcbbInit = '1';
      // Capture phase: runs before the app's own handler, even if it calls preventDefault().
      slot.addEventListener(
        'submit',
        function (e) {
          var form = e.target;
          if (form && form.checkValidity && !form.checkValidity()) return;
          if (slot.dataset.leadFired) return;
          slot.dataset.leadFired = '1';
          fireLead(slot.dataset.tcbbAppForm || 'app_form');
        },
        true
      );
    });
    // Klaviyo embeds announce submits on window (documented event).
    if (!TCBB._klaviyoHooked) {
      TCBB._klaviyoHooked = true;
      window.addEventListener('klaviyoForms', function (e) {
        if (e.detail && e.detail.type === 'submit') fireLead('klaviyo');
      });
    }
  }

  /* ------------------------------------------------------------------- init */
  function init() {
    initCountdowns();
    initPopups();
    initStickyBars();
    initIcsButtons();
    initShareButtons();
    initVendorToggles();
    initAppForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
